import { __awaiter } from 'tslib';

const eventAppPrefix = 'landr-app-';
const eventContentPrefix = 'landr-devtools-content-';
const listeners = {};
const sessionStorageForcedFlagKey = 'landrForcedFlags';
const areDevToolsActive = () => {
    const appBody = document.getElementsByTagName('body')[0];
    const isDevtoolsActive = appBody.getAttribute('data-landr-devtools');
    return !!isDevtoolsActive;
};
const sendToDevTools = (type, payload) => {
    const message = Object.assign({ action: `${eventAppPrefix}${type}` }, payload);
    window.postMessage(message, '*');
};
const listenToWindowMessage = () => {
    if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('message', function (event) {
            return __awaiter(this, void 0, void 0, function* () {
                if (event.source === window &&
                    event.data &&
                    event.data.action &&
                    event.data.action.startsWith(eventContentPrefix)) {
                    const type = event.data.action.substr(eventContentPrefix.length);
                    if (listeners[type]) {
                        listeners[type].forEach((callback) => {
                            try {
                                callback({ payload: event.data });
                            }
                            catch (e) {
                                console.error('[core] cannot call event listener', e);
                            }
                        });
                    }
                }
            });
        });
    }
};
listenToWindowMessage();
/**
 * subscribes to specific event from devtools
 * @return destroy method to unsubscribe
 */
const subscribeFromDevTools = (type, callback) => {
    if (!(type in listeners)) {
        listeners[type] = [];
    }
    listeners[type].push(callback);
    // Destroy method
    return () => {
        if (listeners[type]) {
            const pos = listeners[type].indexOf(callback);
            if (pos >= 0) {
                listeners[type].splice(pos, 1);
            }
        }
    };
};
const getCachedForcedFlags = (applicationName) => {
    var _a;
    const cachedValue = sessionStorage.getItem(sessionStorageForcedFlagKey);
    const parsedCacheValue = cachedValue ? JSON.parse(cachedValue) : {};
    return (_a = parsedCacheValue[applicationName]) !== null && _a !== void 0 ? _a : {};
};
/**
 * Send an event to LANDR devtools with the initial application details
 */
const setupLandrDevTools = (applicationName, applicationVersion, config) => {
    const message = {
        action: `${eventAppPrefix}setup`,
        name: applicationName,
        version: applicationVersion,
        config: config,
        isLocal: process.env.NODE_ENV !== 'production',
    };
    if (areDevToolsActive()) {
        window.postMessage(message, '*');
    }
    else {
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-landr-devtools') {
                    window.postMessage(message, '*');
                    observer.disconnect();
                }
            }
        };
        const observer = new MutationObserver(callback);
        const appBody = document.getElementsByTagName('body')[0];
        observer.observe(appBody, {
            attributes: true,
            childList: false,
            subtree: false,
        });
    }
};

export { areDevToolsActive, getCachedForcedFlags, listeners, sendToDevTools, setupLandrDevTools, subscribeFromDevTools };
